import { useEffect } from "react";

// CRA has no SSR, so this can't help raw (non-JS) social-preview scrapers —
// those read index.html's static <meta> tags. It does help the browser tab
// title and Google, which renders JS before indexing.
export const usePageMeta = (title: string, description: string) => {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [title, description]);
};
